import React from "react";
import { LoaderComponent } from "@fidget/common/components/loader/loader";
import { L10n } from "@fidget/common/i18n";
import styles from "./widgetError.css";

export const WidgetLoader = () => {
  return (
    <div className={styles.wrapper}>
      <LoaderComponent widgetStyle />
      <header>
        <h2>
          <L10n id={"widget.initializing"} />
        </h2>
      </header>
    </div>
  );
};
